import { render, staticRenderFns } from "./GroupAdditionalInfo.vue?vue&type=template&id=406f8785&"
import script from "./GroupAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./GroupAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports